import {CLEAN} from '../../constants';

/**
 * @name cleanNonSessionProfileState
 * @desc Removes data from store not associated with session.gbo.profile; i.e. gma.trips.current
 * @returns {Object}
 * @memberof actions.profile
 * @example
 * // restore state.gmi.gma.trips and state.gmi.gma.rewards to initialState
 * dispatch(actions.profile.cleanNonSessionProfileState());
 */
export function cleanNonSessionProfileState() {
  return {type: CLEAN.CLEAN_PROFILE_STATE};
}
